<template>
  <div>
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="green">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="dialog.form"
      @keydown.esc="dialog.form = false"
      :fullscreen="dialog.fullscreen"
      width="500"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Add Color Palettes

          <v-spacer/>

          <v-icon 
            @click="dialog.form = false"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text
          class="mt-4">
          <v-color-picker
            v-model="color_picker"
            width="500"
            dot-size="15"
            mode="hexa"
            show-swatches
            swatches-max-height="100">
          </v-color-picker>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            @click="addColor()"
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            @click="dialog.form = false"
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col 
        cols="12"
        class="py-0">
        <v-card 
          flat 
          height="calc(100vh - 104px)"
          style="border: 1px solid #E0E0E0; overflow-y: auto;">
          <v-card-text>
            <v-row>
              <v-col
                cols="12"
                md="6">
                <div v-if="process.load">
                  <v-skeleton-loader
                    class="ma-auto"
                    :loading="process.load"
                    type="article, list-item-three-line">
                  </v-skeleton-loader>

                  <v-skeleton-loader
                    class="mx-4 mb-6"
                    width="125"
                    height="125"
                    :loading="process.load"
                    type="image">
                  </v-skeleton-loader>

                  <v-skeleton-loader
                    class="mx-4"
                    width="200"
                    height="200"
                    :loading="process.load"
                    type="image">
                  </v-skeleton-loader>
                </div>

                <ValidationObserver v-else
                  ref="form">
                  <v-form>
                    <ValidationProvider 
                      name="company_name" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Nama Perusahaan
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>

                      <v-text-field
                        filled
                        rounded
                        dense
                        :color="set_color"
                        hide-details
                        placeholder="Contoh. PT Amanata"

                        v-model="form.company_name"
                        :success="form.company_name !== '' && valid"
                        :error-messages="errors"
                        class="mb-6"
                        style="border-radius: 10px; width: 80%;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Nama Perusahaan {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.company_name !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <div
                      class="mb-6">
                      <div class="body-2 mb-2">
                        Favicon
                        <span>
                          (boleh dikosongi)
                        </span>
                      </div>

                      <uploadfavicon
                        v-model="upload.favicon" 
                        style="width: 125px; height: 125px;">
                        <div 
                          slot="activator"
                          class="cursor-pointer">
                          <v-card 
                            flat
                            width="125"
                            height="125"
                            class="d-flex align-center justify-center"
                            style="border-radius: 15px;
                                  border: 2px solid #eaeaea; 
                                  border-style: dashed;">
                            <div v-if="form.fav_icon.length < 1">
                              <v-icon v-if="!process.favicon"
                                size="40" 
                                color="grey">
                                mdi-cloud-upload-outline
                              </v-icon>

                              <v-progress-circular v-else
                                indeterminate
                                :color="set_color">
                              </v-progress-circular>
                            </div>

                            <v-img v-else
                              contain
                              width="125"
                              height="125"
                              :src="form.fav_icon.length > 0 ? form.fav_icon : require('@/assets/logo/favicon.png')" 
                              gradient="to top right, rgba(0,0,0,.2), rgba(0,0,0,.2)"
                              :alt="form.fav_icon"
                              class="text-center d-flex align-center">
                              <div 
                                class="d-flex aling-center justify-center" 
                                style="width: 100%; height: auto;">
                                <v-icon v-if="!process.favicon"
                                  size="40" 
                                  color="white">
                                  mdi-cloud-upload-outline
                                </v-icon>

                                <v-progress-circular v-else
                                  indeterminate
                                  :color="set_color">
                                </v-progress-circular>
                              </div>
                            </v-img>
                          </v-card>
                        </div>
                      </uploadfavicon>
                    </div>

                    <div
                      class="mb-6">
                      <div class="body-2 mb-2">
                        Logo
                        <span>
                          (boleh dikosongi)
                        </span>
                      </div>

                      <uploadlogo
                        v-model="upload.logo" 
                        style="width: 200px; height: 200px;">
                        <div 
                          slot="activator"
                          class="cursor-pointer">
                          <v-card 
                            flat
                            width="200"
                            height="200"
                            class="d-flex align-center justify-center"
                            style="border-radius: 15px;
                                  border: 2px solid #eaeaea; 
                                  border-style: dashed;">
                            <div v-if="form.logo.length < 1">
                              <v-icon v-if="!process.logo"
                                size="60" 
                                color="grey">
                                mdi-cloud-upload-outline
                              </v-icon>

                              <v-progress-circular v-else
                                indeterminate
                                :color="set_color">
                              </v-progress-circular>
                            </div>

                            <v-img v-else
                              contain
                              width="200"
                              height="200"
                              :src="form.logo.length > 0 ? form.logo : require('@/assets/logo/favicon.png')" 
                              gradient="to top right, rgba(0,0,0,.2), rgba(0,0,0,.2)"
                              :alt="form.logo"
                              class="text-center d-flex align-center">
                              <div 
                                class="d-flex aling-center justify-center" 
                                style="width: 100%; height: auto;">
                                <v-icon v-if="!process.logo"
                                  size="60" 
                                  color="white">
                                  mdi-cloud-upload-outline
                                </v-icon>

                                <v-progress-circular v-else
                                  indeterminate
                                  :color="set_color">
                                </v-progress-circular>
                              </div>
                            </v-img>
                          </v-card>
                        </div>
                      </uploadlogo>
                    </div>

                    <div>
                      <div class="body-2 mb-2">
                        Color Palettes
                        <span>
                          (boleh dikosongi)
                        </span>
                      </div>

                      <v-card
                        flat
                        color="#f0f0f0"
                        style="border-radius: 10px;">
                        <v-card-text>
                          <v-btn
                            @click="dialog.form = true"
                            elevation="0"
                            style="background: #4caf5033; border-radius: 10px;"
                            class="body-2 text-capitalize font-weight-bold d-flex align-center green--text">
                            <v-icon size="18">mdi-plus-circle-outline</v-icon>

                            <span class="ml-1">
                              Tambah
                            </span>
                          </v-btn>

                          <div v-if="form.color.length > 0"
                            class="mt-4">
                            <v-chip
                              v-for="(item, index) in form.color"
                              :key="index"
                              :color="item.hex"
                              @click:close="removeColor(index)"
                              @click="setActive(index)"
                              close
                              label
                              class="body-2 mr-2 mb-2"
                              text-color="white"
                              style="height: 36px; border-radius: 10px !important;">
                              <v-icon v-if="item.active"
                                size="20" 
                                color="white" 
                                class="mr-2">
                                mdi-check-bold
                              </v-icon>

                              {{ item.hex }}
                            </v-chip>
                          </div>
                        </v-card-text>
                      </v-card>
                    </div>

                    <div
                      class="body-2 font-weight-bold mt-6 mb-3">
                      Jam Presensi
                    </div>

                    <v-row>
                      <v-col
                        cols="12"
                        md="6"
                        class="py-0">
                        <div>
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>
                            Datang
                            <span class="error--text">
                              (wajib diisi)
                            </span>
                          </div>

                          <v-menu
                            ref="start_time"
                            v-model="time.start"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            :return-value.sync="form.absen_start_time"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                              <ValidationProvider 
                                name="Datang" 
                                rules="required"
                                v-slot="{ errors, valid }">
                                <v-text-field
                                  v-on:keyup.enter="save"
                                  readonly
                                  filled
                                  rounded
                                  dense
                                  :color="set_color"
                                  placeholder="Contoh. 09:00"

                                  hide-details

                                  clearable
                                  @click:clear="form.absen_start_time = ''; form.absen_end_time = '';"
                                  v-on="on"
                                  v-bind="attrs"

                                  v-model="form.absen_start_time"
                                  :success="valid"
                                  :error-messages="errors"
                                  class="mb-6"
                                  style="border-radius: 10px;">
                                  <template v-slot:append-outer>
                                    <div v-if="errors.length > 0">
                                      <v-tooltip top color="#ff5252">
                                        <template v-slot:activator="{ on }">
                                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                        </template>
                                        
                                        Datang {{ errors[0] }}
                                      </v-tooltip>
                                    </div>

                                    <div v-if="form.absen_start_time !== '' && valid">
                                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                                    </div>
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </template>

                            <v-time-picker
                              v-if="time.start"
                              v-model="form.absen_start_time"
                              full-width
                              :color="set_color"
                              format="24hr"
                              @click:minute="$refs.start_time.save(`${form.absen_start_time}`); form.absen_end_time = '';">
                            </v-time-picker>
                          </v-menu>
                        </div>
                      </v-col>

                      <v-col
                        cols="12"
                        md="6"
                        class="py-0">
                        <div>
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>
                            Pulang
                            <span class="error--text">
                              (wajib diisi)
                            </span>
                          </div>
                          
                          <v-menu
                            ref="end_time"
                            v-model="time.end"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            :return-value.sync="form.absen_end_time"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                              <ValidationProvider 
                                name="Pulang" 
                                rules="required"
                                v-slot="{ errors, valid }">
                                <v-text-field
                                  v-on:keyup.enter="save"
                                  readonly
                                  filled
                                  rounded
                                  dense
                                  :color="set_color"
                                  placeholder="Contoh. 17:00"
                                  
                                  hide-details

                                  clearable
                                  @click:clear="form.absen_end_time = ''"
                                  v-on="on"
                                  v-bind="attrs"

                                  v-model="form.absen_end_time"
                                  :success="valid"
                                  :error-messages="errors"
                                  class="mb-6"
                                  style="border-radius: 10px;">
                                  <template v-slot:append-outer>
                                    <div v-if="errors.length > 0">
                                      <v-tooltip top color="#ff5252">
                                        <template v-slot:activator="{ on }">
                                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                        </template>
                                        
                                        Pulang {{ errors[0] }}
                                      </v-tooltip>
                                    </div>

                                    <div v-if="form.absen_end_time !== '' && valid">
                                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                                    </div>
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </template>

                            <v-time-picker
                              v-if="time.end"
                              :min="form.absen_start_time"
                              v-model="form.absen_end_time"
                              full-width
                              :color="set_color"
                              format="24hr"
                              @click:minute="$refs.end_time.save(`${form.absen_end_time}`)">
                            </v-time-picker>
                          </v-menu>
                        </div>
                      </v-col>
                    </v-row>
                  </v-form>
                </ValidationObserver>

                <v-alert 
                  type="error" 
                  text dense prominent 
                  class="mt-6"
                  v-show="message.error.length > 0">
                  {{ message.error }}
                </v-alert>

                <div
                  class="mt-2">
                  <v-btn
                    color="green"
                    elevation="0"
                    style="border-radius: 10px;"
                    class="body-2 font-weight-bold text-capitalize white--text"
                    :disabled="process.form"
                    :loading="process.form"
                    v-on:keyup.enter="save()"
                    @click="save()">
                    <v-icon small class="mr-1">mdi-check-bold</v-icon>
                    Simpan
                  </v-btn>
                </div>
              </v-col>

              <v-col
                cols="12"
                md="6">
                <div
                  class="mb-6">
                  <div class="body-2 mb-2">
                    Banner
                    <span>
                      (boleh dikosongi)
                    </span>
                  </div>

                  <uploadbanner
                    v-model="upload.banner" 
                    style="width: 100%; height: 480px;">
                    <div 
                      slot="activator"
                      class="cursor-pointer">
                      <v-card 
                        flat
                        width="100%"
                        height="480"
                        class="d-flex align-center justify-center"
                        style="border-radius: 15px;
                              border: 2px solid #eaeaea; 
                              border-style: dashed;">
                        <div v-if="form.banner_url.length < 1">
                          <v-icon v-if="!process.banner"
                            size="60" 
                            color="grey">
                            mdi-cloud-upload-outline
                          </v-icon>

                          <v-progress-circular v-else
                            indeterminate
                            :color="set_color">
                          </v-progress-circular>
                        </div>

                        <v-img v-else
                          contain
                          width="100%"
                          height="480"
                          :src="form.banner_url.length > 0 ? form.banner_url : require('@/assets/logo/favicon.png')" 
                          gradient="to top right, rgba(0,0,0,.2), rgba(0,0,0,.2)"
                          :alt="form.banner_url"
                          class="text-center d-flex align-center">
                          <div 
                            class="d-flex aling-center justify-center" 
                            style="width: 100%; height: auto;">
                            <v-icon v-if="!process.banner"
                              size="60" 
                              color="white">
                              mdi-cloud-upload-outline
                            </v-icon>

                            <v-progress-circular v-else
                              indeterminate
                              :color="set_color">
                            </v-progress-circular>
                          </div>
                        </v-img>
                      </v-card>
                    </div>
                  </uploadbanner>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  import { TokenService } from "@/service/Storage.Service";
  export default {
    data () {
      return {
        dialog: {
          snackbar: false,
          form: false
        },
        upload: {
          favicon: null,
          logo: null,

          banner: null
        },
        color_picker: '',
        form: {
          id: '',
          company_name: '',
          logo: '',
          fav_icon: '',
          color: [],
          
          absen_start_time: '',
          absen_end_time: '',

          banner_url: ''
        },
        time: {
          start: false,
          end: false
        },
        process: {
          load: false,
          form: false,
          favicon: false,
          logo: false,

          banner: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfavicon: () => import(/* webpackPrefetch: true */ '@/components/upload/folder.vue'),
      uploadlogo: () => import(/* webpackPrefetch: true */ '@/components/upload/folder.vue'),
      uploadbanner: () => import(/* webpackPrefetch: true */ '@/components/upload/folder.vue')
    },
    watch: {
      'upload.favicon': {
        handler: function () {
          if (this.upload.favicon) {
            this.process.favicon = this.upload.favicon.process

            if (!this.process.favicon) {
              // CALLBACK FROM UPLOAD IMAGE

              this.form.fav_icon = this.upload.favicon.fileuri
            }
          }
        },
        deep: true
      },
      'upload.logo': {
        handler: function () {
          if (this.upload.logo) {
            this.process.logo = this.upload.logo.process

            if (!this.process.logo) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.form.logo = this.upload.logo.fileuri
            }
          }
        },
        deep: true
      },
      'upload.banner': {
        handler: function () {
          if (this.upload.banner) {
            this.process.banner = this.upload.banner.process

            if (!this.process.banner) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.form.banner_url = this.upload.banner.fileuri
            }
          }
        },
        deep: true
      }
    },
    computed: {
      set_color () {
        return this.$store.state.color
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch () {
        this.process.load = true

        await get('admin/config')
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            res.results.data[0].color = JSON.parse(res.results.data[0].color)
            this.form = res.results.data[0]

            TokenService.saveCompany(JSON.stringify(this.form))

            this.$store.commit("setCompany", this.form)

            if (res.results.data[0].color.length > 0) {
              res.results.data[0].color.map((obj) => {
                if (obj.active) {
                  TokenService.saveColor(obj.hex)

                  this.$store.commit("setColor", obj.hex)
                }
              })
            } else {
              TokenService.saveColor('#7550e1')

              this.$store.commit("setColor", '#7550e1')
            }

            this.styles()
          }
        })
      },
      addColor () {
        this.form.color.push({
          hex: this.color_picker,
          active: false
        })

        if (this.form.color.length > 0 && this.form.color.filter((x,i) => { return x.active; }).length < 1) this.form.color[0].active = true

        this.dialog.form = false
      },
      removeColor (index) {
        this.form.color.splice(index, 1)

        if (this.form.color.length > 0 && this.form.color.filter((x,i) => { return x.active; }).length < 1) this.form.color[0].active = true
      },
      setActive (idx) {
        this.form.color.map((obj, index) => {
          if (index === idx) {
            obj.active = true
          } else {
            obj.active = false
          }
        })
      },
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let forms = Object.assign({}, this.form)
          forms.color = JSON.stringify(forms.color)

          // SAVE TO REST API
          await post('admin/config/update', {
            data: forms
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.snackbar = true
              this.message.success = res.message

              this.fetch()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },


      styles () {
        let style = document.createElement('style')
          
        // RESET STYLESHEET TO AUTO
        style.innerHTML = `
          .v-data-table table .v-data-table-header {
            color: white;
            background-color: ${this.set_color}; !important;
          }
          .v-data-table table > thead > tr > th {
            background: ${this.set_color};
          }

          .v-data-table table > tbody .v-data-table__selected .v-input--selection-controls__input {
            color: ${this.set_color};
          }
          .v-data-table table > tbody .v-input--selection-controls__input .v-icon {
            color: ${this.set_color};
          }

          ::-webkit-scrollbar-thumb{
            border-radius: 10px;
            background-color: ${this.set_color};
          }

          #iw-container .iw-title {
            font-family: 'Open Sans Condensed', sans-serif;
            font-size: 22px;
            font-weight: 400;
            padding: 10px;
            background-color: ${this.set_color};
            color: white;
            margin: 0;
            border-radius: 2px 2px 0 0;
          }

          .v-slide-group__prev .v-icon {
            color: ${this.set_color}; !important;
          }

          .v-slide-group__next .v-icon {
            color: ${this.set_color}; !important;
          }

          .table-grid table > thead > tr > th:nth-child(1) {
            left: 0; 
            z-index: 5;
            background: ${this.set_color};
          }

          .v-data-table table > tbody > tr:hover .text-start, table > tbody > tr:hover .text-center,  table > tbody > tr:hover .text-end {
            cursor: pointer;
            // background-color: ${this.set_color_rgb_up} !important;
            background-color: #E0E0E0 !important;
          }
          .v-data-table__selected .text-start, .v-data-table__selected .text-center, .v-data-table__selected .text-end {
            // background-color: ${this.set_color_rgb_up} !important;
            background-color: #E0E0E0 !important;
          }
        `

        // ADD TO APPENDCHILD
        document.head.appendChild(style)
      }
    }
  }
</script>